import { useRef, useEffect, FC } from 'react'
import styled from 'styled-components'

type OptionProps = {
  item: string;
  action: () => void;
};

type DropDownMenu = {
  options: OptionProps[];
  isOpen: boolean;
  onOutsideClickAction?: () => void;
  position?: 'top' | 'bottom' | 'left' | 'right'; // Corregido 'rigth' a 'right'
};

// Estilos dinámicos para el contenedor
const Container = styled.div<{ $position: 'top' | 'bottom' | 'left' | 'right' | undefined }>`
  position: absolute;
  
  z-index: 10;
  ${({ $position }) => {
    switch ($position) {
      case 'top':
        return `
          bottom: 100%;
          left: 0;
        `;
      case 'bottom':
        return `
          top: 100%;
          left: 0;
        `;
      case 'left':
        return `
          top: 0;
          right: 100%;
        `;
      case 'right':
        return `
          top: 0;
          left: 100%;
        `;
      default:
        return `
          top: 130%;
          right: 0;
        `;
    }
  }}
`;

const Menu = styled.ul`
  border-radius: ${({ theme }) => theme.border.radius.base};
  background-color: white;
  border: 1px solid #ccc;
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 200px;
  max-width: 360px;
`;

const MenuItem = styled.li`
  padding: 10px 15px;
  border-radius: ${({ theme }) => theme.border.radius.base};
  cursor: pointer;
  &:hover {
    background-color: #f0f0f0;
  }
`;

/**
 * DropdownMenu component renders a dropdown menu with given options and handles outside click events.
 *
 * @component
 * @param props - The props for the DropdownMenu component.
 * @param props.options - The list of options to display in the dropdown menu.
 * @param props.isOpen - A boolean indicating whether the dropdown menu is open or not.
 * @param props.onOutsideClickAction - Optional callback function to be called when a click outside the menu is detected.
 *
 * @returns {JSX.Element} The rendered DropdownMenu component.
 */
export const DropdownMenu: FC<DropDownMenu> = ({ options, isOpen, onOutsideClickAction, position }) => {
  const menuRef = useRef<HTMLUListElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      onOutsideClickAction?.();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <Container $position={position}>
      {isOpen && (
        <Menu ref={menuRef}>
          {options.map((option, index) => (
            <MenuItem key={index} onClick={option.action}>
              {option.item}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Container>
  );
};
